import React from 'react';
import { Paper, Typography, Box, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const JobListItem = ({ job, index }) => {
  const navigate = useNavigate();

  return (
    <Paper 
      elevation={1}
      sx={{ 
        p: 2,
        cursor: 'pointer',
        '&:hover': {
          elevation: 3,
          transition: 'box-shadow 0.3s ease-in-out'
        }
      }}
      onClick={() => navigate(`/jobs/${job.id}`)}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography 
            variant="h5" 
            component="h2" 
            sx={{ 
              fontWeight: 600,
              color: 'primary.main',
              mb: 1
            }}
          >
            {job.companyName}
          </Typography>
          <Typography 
            variant="h6" 
            component="h3" 
            sx={{ 
              fontWeight: 500,
              mb: 1
            }}
          >
            {job.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {job.companyDesc?.length > 150 
              ? `${job.companyDesc.slice(0, 150)}...` 
              : job.companyDesc}
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {job.description?.length > 150 
              ? `${job.description.slice(0, 150)}...` 
              : job.description}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Chip
            label={job.location}
            color={job.location.toLowerCase() === 'remote' ? 'success' : 'default'}
            size="small"
            sx={{ borderRadius: 1 }}
          />
          {job.status === 1 && (
            <Chip
              label="Active"
              color="primary"
              size="small"
              sx={{ borderRadius: 1 }}
            />
          )}
        </Box>
      </Box>
      {job.salaryRangeMin !== 0 && job.salaryRangeMax !== 0 && (
        <Typography variant="body2" color="text.secondary">
          Salary Range: ${job.salaryRangeMin} - ${job.salaryRangeMax}
        </Typography>
      )}
    </Paper>
  );
};

export default JobListItem;
